import { Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import "regenerator-runtime/runtime";

import ManagerBase from "./ManagerBase";
import Organization from "../models/Organization";

class OrganizationManager extends ManagerBase {
	constructor () {
		super("organizationManager");

		this.responsesModelClass = Organization;
		this.remoteClassName = "organization";
	}

	async getByGuidList (guidList) {
		const rd = NousCore.api.createRequest({ item: { guidList } });

		const result = await this.sendRequest(rd, "get-by-guid-list");
		result.items = result.data.items; // Temporaneo
		return result;
	}

	async getByOwnerGuid (ownerGuid) {
		const rd = NousCore.api.createRequest({ item: { ownerGuid } });
		const requestedAction = "get-by-owner-guid";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						let organization;

						if (data.items.length > 0) {
							organization = new Organization(data.items[0]);
						}

						return {
							data: organization,
							requestedAction,
							status: "ok"
						};
					}
				}
			}
		});
	}

	async getListForCurrentUser (ownerGuid) {
		const rd = NousCore.api.createRequest({ item: { ownerGuid } });
		const requestedAction = "get-list-for-current-user";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const organizationList = Shark.getInstanceList(Organization, data.items);

						Utils.reindexList(organizationList);

						Shark.set({
							organizationList,
						});

						return {
							data: organizationList,
							requestedAction,
							status: "ok"
						};
					}
				}
			}
		});
	}

	async getList () {
		const clientListResult = await super.getList();

		clientListResult.data.sort((a, b) => {
			if (a.name.toLowerCase() > b.name.toLowerCase()) {
				return 1;
			}
			else if (a.name.toLowerCase() < b.name.toLowerCase()) {
				return -1;
			}
		});

		Shark.set({
			clientList: clientListResult.data,
		});
		
		return clientListResult;
	}

	save (organization) {
		const rd = NousCore.api.createRequest({ item: organization.export() });
		const requestedAction = organization.guid === "" ? "insert" : "update";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						if (data.items.length > 0) {
							organization.import(data.items[0]);
						}
						return {
							data: organization,
							requestedAction,
							status: "ok"
						};
				}
			}
		});
	}
}

const organizationManager = new OrganizationManager();

Shark.registerController(organizationManager);

export default organizationManager;